import {computed, makeObservable} from "mobx";
import {ITreeItem} from "./types";
import {ItemModelType} from "../../../stores/WorkspaceStore";

export class DocumentTreeItem implements ITreeItem {
    id: string;
    pinnedLength?: number | undefined;
    childrenIds: string[];
    data: any;

    constructor(itemIdPath: string, itemMST: ItemModelType, formattedChildIds: string[], data: any) {
            this.id = itemIdPath;
            this.childrenIds = formattedChildIds;
            this.data = {
                item: itemMST,
                ...data
            }

        makeObservable(this, {
            isOpen: computed,
        });
    }

    get parentId() {
        return this.id.split('/').slice(0, -1).join('/');
    }

    get isOpen() {
        return this.data.item.isExpanded;
    }

    get isCluster() {
        return this.data.item.isCluster;
    }
}